/* eslint-disable */
export default {
    SET_DESPESAS(state, payload) {
        state.despesas = payload;
    }
}